<script>
    import * as animateScroll from "svelte-scrollto";
    import MediaQuery from "svelte-media-query";
    import { fly } from 'svelte/transition';

    const linkToPlatform = 'https://portal.niowm.com';

    animateScroll.setGlobalOptions({ offset: -70 })

    const navLinks = [
        {name: 'About', id: '#about'},
        {name: 'Features', id: '#features'},
        {name: 'Blog', id: '#blog'},
        {name: 'Contact',  id: '#contact'},
        {name: 'Support', id: '#support'},
    ]
    const logo = 'assets/logo.svg';
    const globe = 'assets/globe.png';
    const aboutImg = 'assets/aboutImg.png';
    const hamburgerImg = 'assets/hamburger.svg';

    let showSideBar = false;
    const handleMenuToggle = () => showSideBar = !showSideBar

    const handleSideBarClose = (e) => {
        if(e.target.outerHTML.includes('sideBarContainer')){
            handleMenuToggle()
        }
    }


</script>


<div class="container">
        <div class="navigation">
            <div class="navigationContainer">
                <div>
                    <img on:click={() => animateScroll.scrollToTop()} src={logo} alt='logo'/>
                </div>
                <div>
                    <MediaQuery query="(min-width: 769px)" let:matches>
                        {#if matches}
                            <ul class='navLinks'>
                                {#each navLinks as nav }
                                    <li on:click={() => animateScroll.scrollTo({element: nav.id})}> {nav.name} </li>    
                                {/each}
                                <li><a href={linkToPlatform} class='loginButton'> Login </a></li>
                            </ul>
                        {/if}
                    </MediaQuery>
                    <MediaQuery query="(max-width: 769px)" let:matches>
                        {#if matches}
                            <div class="hamburgerButton" on:click={handleMenuToggle}>
                                <img src={hamburgerImg} alt='hamburgerImg'/>
                                <div>Menu</div>
                            </div>
                        {/if}
                    </MediaQuery>
                </div>
            </div>
        </div>

        <div class="hero">
            <div class='heroContent'>
                <div class="mainHeader">
                    Managing all your assets through one platform
                </div>
                <div class="subHeader">
                    Exchange, send, receive, sell and buy currencies easy, fast and secure.
                </div>
                <a href={`${linkToPlatform}/sign-up`} class='nioButton'>Get started today</a>
            </div>
            <div>
                <img class="globeImg" src={globe} alt='globe'/>
            </div>
        </div>

        <div class="about" id='about'>
            <div >
                <img class="aboutImg" src={aboutImg} alt='aboutImg'/>
            </div>
            <div class="aboutDescription">
                <div class="aboutMainHeader"> About NIO </div>
                <div class="aboutSubHeader"> NIO is a product who was created giving enhanced abilities to the new financial environment we experience on daily bases. </div>
                <div class="aboutParagraf"> <b>Easy to use</b> - We took all the average user’s concerns, obstacles, wishes and needs and created a seamless asset management toll, who provides all necessary to control, transfer, receive, exchange, buy and sell your financial assets.</div>
                <div class="aboutParagraf"> <b>All in one place</b> - We understand that as the financial world moving forward, creating variety of tools, coins and asset to manage, our customers will need one toll, easy to use, to manage all. </div>
                <div class="aboutParagraf"> <b>Advanced </b> - We are using the best technologies with all the platform components (KYC, AML, CRYPTO, BLOCKCHAIN, FINANCIAL SERVICES…) authorized by EU regulators in to one. </div>
            </div>
        </div>

</div>

{#if showSideBar}
    <div class='sideBarContainer' on:click={handleSideBarClose}>
        <div class="sideBar" transition:fly={{x: -350, opacity: 1}} >
            <img class='logoSideNavBar' on:click={() => animateScroll.scrollToTop()} src={logo} alt='logo'/>
            <ul class='navLinksMenu' on:click={handleMenuToggle}>
                {#each navLinks as nav }
                    <li on:click={() => animateScroll.scrollTo({element: nav.id})}> {nav.name} </li>    
                {/each}
                <li><a href={linkToPlatform} class='loginButton'> Login </a></li>
            </ul>
        </div>
    </div>
{/if}




<style>

    .sideBarContainer{
        position: fixed;
        background-color: #6e606080;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
        width: 100%;
    }

    .sideBar{
        position: fixed;
        background-color: #FFFFFF;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        width: 70%;
    }

    .logoSideNavBar{
        margin-left: 15px;
        margin-top: 20px;
    }

    .container{
        max-width: 1170px;
        margin: 0 auto;
        padding: 0 30px;
    }
    
    .navigation{
        position: fixed;
        width: 100%;
        top: 0;
        background: white;
        left: 0;
        right: 0;
        z-index: 99999;
    }

    .navigationContainer{
        max-width: 1170px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        height: 64px;
    }

    .navigationContainer > div:first-child{
            margin-left: 10px;
        }


    ul{
        display: flex;
        list-style-type: none;
    }

    li{
        margin-right: 25px;
        cursor: pointer;
        font-weight: 600;
        font-size: 14px;

    }


    .hero{
        display: flex;
        justify-content: space-between;
        margin-top: 100px;
    }

    .hero > div{
        flex: 1
    }

    .heroContent{
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .mainHeader{
        color: #3A3A3C;
        font-size: 40px;
        letter-spacing: -1px;
        line-height: 44px;
        text-align: left;
        font-weight: 500;
    }

    .subHeader{
        color: #666666;
        font-size: 20px;
        line-height: 26px;
        text-align: left;
        margin: 20px 0;
        max-width: 490px;
    }

    .nioButton{
        background: linear-gradient(180deg, #F77E36 0%, #EB6210 100%);;
        border-radius: 4px;
        width: 240px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-size: 16px;
        cursor: pointer;
        text-decoration: none;
    }

    
    .nioButton:hover{
        background-color: #fd9153;
    }

    .globeImg{
        width: 100%;
        height: 100%;
    }


    .about{
        margin-top: 100px;
        display: flex;
    }

    .about > div:first-child{
        flex: 0.5;
        margin-right: 50px;

    }
    .about > div:last-child{
        flex: 1;
        max-width: 770px;
    }

    .aboutImg{
        max-width: 350px;
        height: 323px;
    }

    .aboutMainHeader{
        font-size: 32px;
        letter-spacing: -1px;
        line-height: 36px;
    }

    .aboutSubHeader{
        color: #3A3A3C;
        font-size: 20px;
        line-height: 26px;
        margin: 10px 0;
    }

    .aboutParagraf{
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 10px;
        color: #666666;
    }


    .loginButton{
        background: linear-gradient(180deg, #F77E36 0%, #EB6210 100%);
        border-radius: 4px;
        width: 95px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-size: 14px;
        cursor: pointer;
        text-decoration: none;
    }


    .loginButton:hover{
        background-color: #fd9153;
    }

    .navLinks{
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .navLinksMenu{
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .navLinksMenu > li{
        font-size: 20px;
        margin-bottom: 20px;
        font-weight: 600;
    }

    .hamburgerButton{
        display: flex;
        margin-right: 10px;
        border: 2px solid #DDDDDD;
        padding: 5px 10px;
        border-radius: 4px;

    }

    .hamburgerButton > img{
        margin-right: 10px;
    }

    @media (max-width: 769px) { 


        .about{
            margin-top: 50px;
        }

        .hero {
            flex-direction: column-reverse; 
        }

        .heroContent{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 20px;

        }   

        .mainHeader{
            color: #3A3A3C;
            font-size: 32px;
            text-align: center;
        }

        .subHeader{
            color: #666666;
            font-size: 20px;
            text-align: center;
        }

        .about{
            display: flex;
            flex-direction: column;
            align-items: center;
        }


        .about > div:first-child{
            flex: 0.5;
            margin-right: 0px;

        }
        .about > div:last-child{
            flex: 1;
        }

        .aboutImg{
            width: 100%;
            height: 323px;
        }

        .aboutMainHeader{
            font-size: 32px;
            letter-spacing: -1px;
            line-height: 36px;
        }

        .aboutSubHeader{
            color: #3A3A3C;
            font-size: 20px;
            line-height: 26px;
            margin: 10px 0;
        }

        .aboutParagraf{
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 10px;
        }

    }


</style>

